module.exports = __webpack_public_path__ + "img/couples_03_V.0fe5f7b7.jpg";